import styled from 'styled-components';
import { TextField } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import { Styling, Colors } from '../../../constants';
import StyledSelect from '../../Shared/Select';

/* eslint-disable no-confusing-arrow */

interface IFormGroupProps {
  disabled?: boolean;
  children?: React.ReactNode;
}

type IFormRowProps = IFormGroupProps;

export const ProgressContainer = styled.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;

export const StickyProgressContainer = styled(ProgressContainer)`
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  position: sticky;
`;

export const Form = styled.div`
  min-height: 400px;
`;

export const Label = styled.h1`
  cursor: default;
  text-align: left;
  font-weight: bolder;
`;

export const FormGroup = styled.div<IFormGroupProps>`
  padding: ${Styling.DEFAULT_SPACING}px;
  ${(props) => props.disabled ? `
    ${Label} {
      color: ${Colors.LIGHT_GREY};
    }
  ` : null}
`;

export const Select = styled(StyledSelect)`
  margin-top: ${Styling.DEFAULT_SPACING - 5}px;
`;

export const FormRow = styled.div<IFormRowProps>`
  display: flex;
  flex-flow: row wrap;
  ${FormGroup} {
    width: 50%;
  }
  &.upload-form-row {
    ${FormGroup}:nth-child(1) {
      width: 70%;
    }
    ${FormGroup}:nth-child(2) {
      width: 30%;
    }
    /* VV-226: the comment wraps onto its own line and takes the full width - a free-text
       field is the one thing in this row that benefits from the space, and without this it
       would fall back to the generic 50% and sit awkwardly half-width. */
    ${FormGroup}:nth-child(3) {
      width: 100%;
    }
  }
  ${(props) => props.disabled ? `
    ${FormGroup} {
      ${Label} {
        color: ${Colors.LIGHT_GREY};
      }
    }
  ` : null}
`;

export const StyledTextField = styled(TextField)`
  margin-top: ${Styling.DEFAULT_SPACING - 5}px;
  input {
    padding: ${Styling.DEFAULT_SPACING}px !important;
  }
`;

export const StyledDatePicker = styled(DatePicker) <DatePickerProps<Date>>`
margin-top: ${Styling.DEFAULT_SPACING - 5}px;  
input {
    padding: ${Styling.DEFAULT_SPACING}px;
  }
`;

export const TeamIcon = styled.img`
  display: inline-block;
  margin-right: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  height: 1rem;
  width: 1rem;
  position: relative;
  top: 2px;
`;
